import { render, staticRenderFns } from "./BoardRemoveIcon.vue?vue&type=template&id=3878b958&scoped=true"
import script from "./BoardRemoveIcon.vue?vue&type=script&lang=js"
export * from "./BoardRemoveIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3878b958",
  null
  
)

export default component.exports